import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { reduxForm, reset } from 'redux-form';
import { notification } from 'antd';
import { withRouter } from 'react-router';
import LineItemAdd from '../../../components/molecules/LineItemAdd/index';
import { isOpen } from '../../../store/modal/selectors';
import { modalHide } from '../../../store/modal/actions';
import { createValidator, required, maxLength } from '../../../services/validation/index';
import { resourceCreateRequest } from '../../../store/resource/actions';
import { fromEntities } from '../../../store/selectors';

const LineItemAddContainer = props => <LineItemAdd {...props} />;

const onSubmit = (values, dispatch, props) => {
  const { campaignId } = props.match.params;

  const submitVals = values;
  if (values.rangepicker) {
    submitVals.start_date = values.rangepicker[0];
    submitVals.end_date = values.rangepicker[1];
    delete submitVals.rangepicker;
  }

  submitVals.approval_status = 'Approved';

  return props
    .createLineItem({ advertiser_campaign_id: parseInt(campaignId, 10), status: 1, ...submitVals })
    .then(lineItemId => {
      // Redirect to new line item.
      props.onCancel();
      dispatch(reset('LineItemAdd'));
      props.history.push(`/campaigns/${campaignId}/line/${lineItemId}`);
      notification.success({ message: 'Success', description: 'Line item created.', duration: 4 });
    })
    .catch(e =>
      notification.error({
        message: 'Error',
        description: typeof e === 'string' ? e : 'Could not create your line item.',
        duration: 0,
      })
    );
};

const validate = createValidator({
  name: [required, maxLength(80)],
  start_date: [required],
  end_date: [required],
});

const mapStateToProps = (
  state,
  {
    match: {
      params: { campaignId },
    },
  }
) => {
  const campaign = fromEntities.getDetail(state, 'advertiserCampaign', campaignId);
  return {
    initialValues: {
      start_date:
        campaign.start_date && campaign.start_date.length <= 11
          ? `${campaign.start_date} 00:00:00`
          : null,
      end_date:
        campaign.end_date && campaign.end_date.length <= 11
          ? `${campaign.end_date} 23:59:59`
          : null,
    },
    visible: isOpen(state.modal, 'LineItemAdd'),
  };
};

const mapDispatchToProps = dispatch => ({
  createLineItem: data => dispatch(resourceCreateRequest('advertiser-ad', {}, data)),
  onCancel: () => dispatch(modalHide('LineItemAdd')),
});

export default compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  reduxForm({
    enableReinitialize: true,
    destroyOnUnmount: false,
    form: 'LineItemAdd',
    onSubmit,
    validate,
  })
)(LineItemAddContainer);
